// extracted by mini-css-extract-plugin
export default {"container":"PromoCsMoney_container__l1p6R"};